export default [
  {
    title: "Le concept",
    values: [
      {
        family: "Le concept",
        ask: "Comment fonctionne Sneakbox ?",
        answer: `
            L’adhésion à la Sneakbox vous permet d’accéder à notre collection de sneakers.
            <br><br>
            Chaque mois, vous choisissez votre paire et là recevez chez vous. Les frais de livraison et de nettoyage sont gratuit !
        `
      },
      {
        family: "Le concept",
        ask: "Que comprend la formule que j’ai choisie ?",
        answer: `
        Nous avons actuellement deux formules :<br>
        <br>
        La formule Lover à 75€/mois qui contient :<br>
        - Une paire de basket par mois<br>
        - Paire d’une valeur maximum de 400€<br>
        - Livraison et retour gratuit<br>
        - Nettoyage gratuit<br>
        <br>
        La formule Addict à 95€/mois qui contient :<br>
        - Une paire de basket par mois<br>
        - Paire d’une valeur maximum de 600€<br>
        - Livraison et retour gratuit<br>
        - Nettoyage gratuit<br>
        <br><br>
        Vous pouvez également conserver la paire plusieurs mois.
        `
      },
      {
        family: "Le concept",
        ask: "Est-ce que je peux garder mes sneakers à la fin du mois ?",
        answer: `
            Vous pouvez garder les paires que vous recevez aussi longtemps que vous êtes abonné à la Sneakbox.<br>
            <br>
            Vous ne rendez votre paire que pour l’échanger contre une autre ou si vous mettez fin à votre abonnement.
        `
      },
      {
        family: "Le concept",
        ask: "Est-ce que je peux annuler mon abonnement ?",
        answer: `
            Bien sur ! Nous serions tristes de vous voir nous quitter mais vous pouvez vous désabonner à n’importe quel moment.
            <br><br>
            Vous pourrez continuer à profiter de nos services jusqu'à la fin du mois en cours.
            <br><br>
            Votre désinscription sera effective après que vous nous ayez renvoyé toutes les paires Sneakbox que vous avez en votre possession.
        `
      },
      {
        family: "Le concept",
        ask: "Quelles type de paires possédez-vous ?",
        answer: `
            Nous sommes aussi passionnés de sneakers que vous !
            <br><br>
            Pour cette raison, nous nous efforçons de collecter des modèles récents et/ou rare et quelques classiques.
            <br><br>
            S’il y a des paires ou des coloris que vous voulez voir apparaître dans notre collection, faite le nous savoir par email : <a href="mailto:sneakboxapp@gmail.com">sneakboxapp@gmail.com</a>
        `
      },
      {
        family: "Le concept",
        ask: "Quels sont les tailles que vous proposez ?",
        answer: `
            Nous vous proposerons toujours des paires à votre pointure.
            <br><br>
            S’il y a des différences de taille d’une marque à l’autre, nous nous efforcerons de vous proposer celle qui vous correspond le plus.
            <br><br>
            Si la paire que vous recevez est trop petite ou trop grande, vous pourrez facilement l’échanger contre une pointure différente.
            <br>
            Nous retiendrons vos préférences pour la prochaine fois.
        `
      },
      {
        family: "Le concept",
        ask: "Je me suis trompé de taille. Puis-je effectuer un échange ?",
        answer: `
            Si vous commandez une taille qui ne vous convient pas, vous pouvez facilement l'échanger contre la bonne taille.
            <br><br>
            Une fois votre commande livrée, vous disposez d'un délai de 7 jours pour procéder à l’échange.
        `
      }
    ]
  },

  {
    title: "Livraison et échanges",
    values: [
      {
        family: "Livraison et échanges",
        ask: "Quand est-ce que je vais recevoir ma paire ?",
        answer: `
           Vous recevrez votre paire sous 5 jours ouvrés après votre commande.
           <br><br>
        `
      },
      {
        family: "Livraison et échanges",
        ask: "Suis-je facturé pour l’envoi de ma paire ?",
        answer: `
           Non ! Tous les frais d’expédition, d’échange et de retours sont gratuits.
        `
      },
      {
        family: "Livraison et échanges",
        ask: "Comment se déroule l’échange de paire ?",
        answer: `
            Pour échanger votre paire contre une autre, vous devez vous connecter sur la plateforme et sélectionner la nouvelle paire que vous souhaitez recevoir.
        `
      }
    ]
  },
  {
    title: "Nettoyage et Assurance",
    values: [
      {
        family: "Nettoyage et Assurance",
        ask: "Dans quel état sont les paires que je reçois ?",
        answer: `
            Toutes les paires que vous recevrez seront dans un état neuf ou proche du neuf, nettoyé par nos experts.
            <br><br>
            Nous nous assurons de nettoyer et rénover toutes les paires que vous nous renvoyez afin qu’elles retrouvent un état proche du neuf.
            <br><br>
            Ainsi, nous redonnons plusieurs vies aux paires de notre collection 🌱.
        `
      },
      {
        family: "Nettoyage et Assurance",
        ask: "Que se passe-t-il si je salis la paire ?",
        answer: `
            Rien du tout !
            <br><br>
            Nous nous occupons de la nettoyer après que vous nous l’ayez renvoyé, vous n’avez aucun souci à vous faire.
        `
      },
      {
        family: "Nettoyage et Assurance",
        ask: "Que se passe-t-il si j’abime la paire ?",
        answer: `
            Tout dépend à quel point la paire est abîmée.
            <br><br>
            Dans la plupart des cas il ne se passera rien du tout car notre équipe est capable de rénover les paires même les plus abîmés.
            <br><br>
            Mais dans le cas d’une brûlure, d’une grosse déchirure ou d’une partie de la paire manquante (ex: retour sans semelle), une caution de 75% de la valeur actuelle de la paire sera prélevé.
            <br><br>
            Dans tous les cas, si la paire est abimée n’essayez pas de la réparer vous-même et renvoyez là dès que possible.
        `
      },
      {
        family: "Nettoyage et Assurance",
        ask: "Que se passe t’il si je ne rend pas la paire ?",
        answer: `
            Si vous avez perdu ou détruit une paire, vous devrez payer une caution de 125% de la valeur actuelle de la paire.
            <br><br>
            Lorsque vous décidez de faire un échange, vous disposez d’un délai de 5 jours pour nous rendre la paire que vous aviez en votre possession.
            <br><br>
            Si vous ne renvoyez pas la paire dans ce délai, il vous sera prélevé 30€ pour chaque semaine de retard sur l’envoi du colis.
        `
      }
    ]
  }
];
